export default {
    OPEN_ALERT: (state, { headerTitle, bodyContent, bodyContentHtml, alertType, selectedItem, btnConfig = undefined, resolve = () => { }, }) => {
        state.headerTitle = headerTitle;
        state.bodyContent = bodyContent;
        state.bodyContentHtml = bodyContentHtml;
        state.alertType = alertType;
        state.selectedItem = selectedItem;
        state.btnConfig = btnConfig;
        state.resolve = resolve;
        state.open = true;
    },
    CLOSE_ALERT: (state) => {
        state.headerTitle = '';
        state.bodyContent = '';
        state.bodyContentHtml = '';
        state.alertType = '';
        state.selectedItem = '';
        state.open = false;
    },
};
